import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, input, computed, signal, PLATFORM_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ModalService } from '../../../services/modals/modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService, LOGIN_TYPE_BID_INLINE, LOGIN_TYPE_COMPLETE_REGISTRATION, LOGIN_TYPE_PASSWORD_RESET, LOGIN_TYPE_REGISTER, LOGIN_TYPE_TICKETS, LOGIN_TYPE_TOPBAR } from '../../../services/authentication/auth.service';

export const SIGN_IN_MODAL_NAME = 'app-sign-in';

@Component({
  selector: 'app-sign-in',
  imports: [ReactiveFormsModule, CommonModule, ButtonModule, DynamicDialogModule],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignInComponent {
  readonly loginTypeTopbar = LOGIN_TYPE_TOPBAR;
  readonly loginTypeTickets = LOGIN_TYPE_TICKETS;
  readonly loginTypeBidInline = LOGIN_TYPE_BID_INLINE;
  readonly loginTypeRegister = LOGIN_TYPE_REGISTER;
  readonly loginTypePasswordReset = LOGIN_TYPE_PASSWORD_RESET;
  readonly loginTypeCompleteRegistration = LOGIN_TYPE_COMPLETE_REGISTRATION;

  private readonly modalService = inject(ModalService);
  private readonly platformId = inject(PLATFORM_ID);

  private sanitizer = inject(DomSanitizer);
  private authService = inject(AuthService);

  // private modalService = inject(ModalService);
  loginUrl = input('');
  safeLoginUrl = computed(() => this.sanitizer.bypassSecurityTrustResourceUrl(this.loginUrl()));
  loginPage = input(this.loginTypeTopbar);


  alternativeCallback = input(function () { });
  auctionId = input(0);
  hideGuestOption = input(false);

  protected cookiesEnabled = signal(true);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.cookiesEnabled.set(navigator.cookieEnabled);
    }
  }

  // @Output() closeSignIn = new EventEmitter<void>();

  // openForgotPassword() {

  //   this.modalService.closeModal('signIn');

  //   const ref = this.modalService.openModal('forgotPassword', ForgotPasswordComponent, {
  //     width: '750px',
  //     modal: true,
  //     closable: true,
  //     contentStyle: { height: '300px' },
  //     dismissableMask: true,
  //     breakpoints: {
  //       '960px': '75vw',
  //       '640px': '90vw'
  //     }
  //   });

  //   ref.onClose.subscribe(result => {
  //     if (result) {
  //       console.log(result);

  //     }
  //   });

  // }
  iframeClass = computed(() => {
    switch (this.loginPage()) {
      case this.loginTypeBidInline:
        return 'w-[80vw] md:w-[350px] min-h-[375px]';
      case this.loginTypePasswordReset:
        return 'w-[350px] lg:w-[750px] min-h-[200px]'
      case this.loginTypeCompleteRegistration:
        return 'w-[350px] lg:w-[750px] md:min-h-[275px] min-h-[335px]';
      case this.loginTypeRegister:
        return 'w-[350px] lg:w-[750px] md:min-h-[435px] min-h-[620px]';
      default:
        return 'w-[350px] lg:w-[750px] min-h-[375px]';
    }
  });

  continueAsGuest() {
    this.authService.continueAsAGuest(this.alternativeCallback());
  }

  protected openLoginModal() {
    this.modalService.closeModal('app-sign-in');
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, () => {}, this.auctionId())
  }

  protected openRegisterModal() {
    this.modalService.closeModal('app-sign-in');
    this.authService.openLoginModal(LOGIN_TYPE_REGISTER, () => {}, this.auctionId())
  }

}
